import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from '@aws-amplify/ui-react'
import { useNavigate } from 'react-router'
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness'
import { mdiArrowRight, mdiRefresh } from '@mdi/js'
import Button from '@components/Button'
import ButtonGroup from '@components/Button/Group'
import livenessDictionary from '@constants/livenessDictionary'
import createAlert from '@modules/app/scripts/alert/createAlert'
import { setFoto } from '@modules/convite/reducers/conviteReducer'
import { setAlert } from '@modules/app/reducers/alertReducer'
import { getSessionId, validateLiveness } from '@modules/convite/controllers/conviteController'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import conditionaRender from '@utils/conditionalRender'
import './styles.scss'
import { useQuery } from '@utils/queryParams'
import ValidationMessage from './Components/ValidationMessage'

const ConviteLiveness: React.FC = () => {

    const dispatch = useAppDispatch()

    const { sessionId, validateLivenessResult } = useAppSelector(s => s.convite)
    const { requestGetSessionId, requestValidadeLiveness } = useAppSelector(s => s.requestConvite)
    const idVisitante = useQuery().get("idVisitante")
    const navigate = useNavigate()
    const [check, setCheck] = useState(true)
    const CR_SESSION = conditionaRender(requestGetSessionId, sessionId)
    const CR_VALIDATE_LIVENESS = conditionaRender(requestValidadeLiveness, validateLivenessResult)

    const SHOW_DATA = CR_SESSION.DATA && !CR_VALIDATE_LIVENESS.DATA
    const SHOW_RESULT = !CR_SESSION.LOADING && CR_VALIDATE_LIVENESS.DATA

    const handleAnalysisComplete = async () => {
        await validateLiveness(dispatch, sessionId, idVisitante.replaceAll(' ','+') )
    }

    const handleGetSessionId = useCallback(() => {
        getSessionId(dispatch)
    }, [dispatch])

    const handleRetry = () => {
        handleGetSessionId()
    }

    const handleSave = () => {
        dispatch(setFoto(`https://livenessresult.s3.us-east-1.amazonaws.com/${validateLivenessResult.body.ReferenceImage.S3Object.Name}`))
        
        navigate(-1)
    }

    useEffect(() => {
        handleGetSessionId()
    }, [dispatch, handleGetSessionId])

    return(

        <>
            {CR_SESSION.LOADING && <Loader />}
            {SHOW_RESULT && (
                <div id = "livenessResult">
                    {(validateLivenessResult.body.Confidence >= 70 && validateLivenessResult.body.validation.isValid) && (
                        <>
                            <h1 className = "status success">Verificação realizada com sucesso</h1>
                            {/* <p>Confiança: {validateLivenessResult.body.Confidence}</p> */}

                            <img
                                src = {`https://livenessresult.s3.us-east-1.amazonaws.com/${validateLivenessResult.body.ReferenceImage.S3Object.Name}`}
                                alt = "Foto de referência"
                                width = {200}
                                height = "auto"
                            />

                            <ButtonGroup>
                                <Button
                                    label = "Tentar novamente"
                                    icon = {mdiRefresh}
                                    status = "info"
                                    onClick = {handleRetry}
                                />
                                <Button
                                    label = "Continuar"
                                    icon = {mdiArrowRight}
                                    status = "success"
                                    onClick = {handleSave}
                                />
                            </ButtonGroup>
                        </>
                    ) || (
                        <div>
                           <h1 className = "status error">Não foi possível verificar sua identidade.</h1><br></br>
                           {/* { validateLivenessResult.body.Confidence < 80 && <p>Confiança de {validateLivenessResult.body.Confidence} </p> }  */}
                    
                    { validateLivenessResult.body.Confidence >= 80 && <h3 style={{textAlign: 'center'}} className = "status info">Problemas detectados na foto enviada:</h3>}
                    <ul style={{textAlign: 'center'}}>
                    { validateLivenessResult.body.Confidence >= 80 && validateLivenessResult.body.validation.messages.map((mensagem ) => (
                    <li> <br></br>
                    <h3> - {mensagem} </h3>
                    </li>
            ))}
                    </ul>
                    <br></br>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                    <Button
                    
                        label = "Clique aqui para tentar novamente"
                        icon = {mdiRefresh}
                        status = "info"
                        onClick = {handleRetry}
                    />
                    </div>
                        </div>
                    )}
                </div>
            )}
            {SHOW_DATA && (

<>
                {(!check && <ValidationMessage check={check} setCheck={setCheck} />)
                ||
                (<FaceLivenessDetector
                
                    sessionId = {sessionId}
                    region = "us-east-1"
                    displayText = {livenessDictionary}
                    onAnalysisComplete = {handleAnalysisComplete}
                    disableStartScreen
                    onError = {error => {
                     //   dispatch(setAlert(createAlert('error', error.error.message)))
                        handleRetry()
                    }}
                    onUserCancel = {() => {
                        dispatch(setAlert(createAlert('warning', 'Verificação cancelada')))
                        navigate(-1)
                        //handleRetry()
                    }}
                />)}
                </>
            )}
        </>

    )

}

export default ConviteLiveness